// Brand colour tokens.
//
// `const PINK = '#FB3AAE'` was declared independently in 44 files, with GREEN,
// AMBER and BLUE repeated alongside it. One definition here means a rebrand is
// one edit rather than a grep-and-pray across the whole portal.
//
// These mirror the CSS custom properties in styles/globals.css (--accent is the
// same pink). Use the CSS variable in stylesheets; use these where a colour has
// to be computed in TypeScript — inline style objects, canvas, gradients.

/** BMC accent pink. Mirrors --accent / --text-sidebar-active / --border-focus. */
export const PINK = '#FB3AAE'

/** Positive money / success states. */
export const GREEN = '#16a34a'

/** Warnings and pending states. */
export const AMBER = '#fbbf24'

/** Secondary chart series, and the brand-avatar gradient's cool end. */
export const BLUE = '#4A90E2'
